<template>
  <div class="content">
    <div class="total">
      <div>
        <span class="title">抵押活畜(头)：</span>
        <span class="value">{{ infoObj?.superviseLiveStockCount||0}}</span>
      </div>
      <div>
        <span class="title">现有活畜(头)：</span>
        <span class="value">{{infoObj?.allcount||0}}（大牛 {{infoObj?.bigCount||0}}头 牛犊 {{infoObj?.smallCount||0}}头）</span>
      </div>
      <div>
        <span class="title">繁殖率：</span>
        <span class="value">{{ infoObj?.breedRate||0}}%</span>
      </div>
    </div>
    <div class="chart" id="chart"></div>
  </div>
</template>

<script>
export default {
  components: {},
  props:{
    loanYearQuery:{
        type:Object,
    }
  },
  data() {
    return {
        infoObj:{}
    }
  },
  watch:{
    'loanYearQuery':{
        handler(){
            this.getInfo()
        },
        immediate:true,
        deep:true
    }
},

  methods: {
    getInfo(){
        this.$http({
            url: 'ffsapp-service/superviseProperty/queryLiveDynamicsStatistics',
			method: 'post',
            data:this.loanYearQuery
        }).then((res)=>{
            this.infoObj=res.data.result||{}
            let rawData=[]
			let rawDataObj={bigCount:[],smallCount:[]}
            this.infoObj?.liveDynamicsStatisticsModels?.map((item)=>{
                rawData.push(Number(item.bigCount)+Number(item.smallCount))
				rawDataObj.bigCount.push(Number(item.bigCount))
				rawDataObj.smallCount.push(Number(item.smallCount))
            })
           this.setChart(rawDataObj)
        })
    },
    setChart(rawDataObj) {
		console.log(rawDataObj)
      this.chart = this.$echarts.init(document.getElementById('chart')).dispose()
      this.chart = this.$echarts.init(document.getElementById('chart'))
      const series = ['大牛', '牛犊'].map((name, sid) => {
        return {
          name,
          type: 'bar',
          stack: 'total',
          barWidth: '15%',
          label: {
            show: false,
            // formatter: (params) => Math.round(params.value * 1000) / 10 + '%',
          },
          data: name=='大牛'?rawDataObj.bigCount:rawDataObj.smallCount,
        }
      })
	  console.log(series)
      var option = {
        color: ['#EFAB44', '#85BC3C'],
        legend: {
          selectedMode: true,
          right: 0,
          itemWidth: 13,
          itemHeight: 12,
          textStyle: {
            color: '#fff',
          },
        },
        grid: {
          left: 40,
          right: 100,
          top: 50,
          bottom: 20,
        },
        series,
        yAxis: {
          type: 'value',
          axisLine: {
            symbol: ['none', 'arrow'],
            symbolSize: [8, 8],
            symbolOffset: [0, 10],
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.15)',
            },
          },
          axisLabel: {
            color: '#fff',
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.05)',
              type: 'dashed',
            },
          },
        },
        xAxis: {
          type: 'category',
          data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月','8月','9月','10月','11月','12月'],
          axisLabel: {
            color: '#FFFFFF',
          },

          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.15)',
              width: 3,
              type: 'dashed',
              opacity: '0.2',
            },
          },
          axisTick: {
            show: false,
          },
        },
      }
      this.chart.setOption(option)
    },
  },
}
</script>

<style scoped lang="scss">
.content {
  .total {
    width: 100%;
    height: 0.425rem;
    display: flex;
    font-size: 0.15rem;
    font-family: Source Han Sans, Source Han Sans;
    font-weight: 400;
    color: #ffffff;
    align-items: center;
    margin-top: 0.3rem;
    div {
      margin-right: 0.95rem;
      display: flex;
      align-items: flex-end;
      .title {
        font-size: 0.15rem;
        font-family: Source Han Sans, Source Han Sans;
        font-weight: 400;
        color: #ffffff;
        display: inline-block;
      }
      .value {
        font-size: 0.25rem;
        font-family: DIN, DIN;
        font-weight: 700;
        color: #efab44;
        display: inline-block;
      }
    }
  }
  .chart {
    width: 100%;
    height: 3.5rem;
    // background: orange;
    margin-top: 0.3rem;
  }
}
</style>
